import { GardensDatatable } from "datatables/gardens"
export default class GardensIndex extends ApplicationController {
  connect () {
    this.datatable = new GardensDatatable()
  }
}